module.exports = "query customLinks{customLinks{...ShortUrlFields}}fragment ShortUrlFields on ShortUrl{longUrl shortUrl created timesUsed type description}"